<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">设备监控</div>
        <div class="refreshButton">
          <el-button size="mini" @click="init">刷新</el-button>
        </div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0rem">
        <div class="zj-search-result-table">
          <el-table
            :data="tableData"
            :show-header="false"
            v-loading="searching"
            element-loading-text="加载中..."
          >
            <el-table-column>
              <template slot-scope="scope">
                <MonitorInfoPanel
                  v-bind:info="convert(scope.$index, scope.row)"
                ></MonitorInfoPanel>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import utils from "../../../../../../utils";
import MyApis from "../../../apis";
import MonitorInfoPanel from "../component/MonitorInfoPanel";
export default {
  name: "EquipmentMonitorView",
  controller: "UI",
  action: "EquipmentMonitorView",
  components: {
    MonitorInfoPanel: MonitorInfoPanel,
  },
  data() {
    return {
      searching: false, // 搜索中...
      tableData: [],
      EquTypeArr: [],
      Servers: [],
    };
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    // this.search();
    this.logInfo.ActionName = "设备资源监控查看";
    this.logInfo.LogMessage = "设备资源监控查看";
    this.logInfo.ModuleName = "设备资源监控";
    this.logInfo.PageName = "设备资源监控页";
    this.addOperationLog();
  },
  methods: {
    init() {
      this.searching = true;
      utils
        .waitAll([
          this.config.getUValue("EquMonitorSubSystem:EquType", ""),
          new MyApis.TranResourcesApi().FindAllServerEquipment(),
          new MyApis.TranResourcesApi().FindEquipmentUseDetail(),
        ])
        .then((r) => {
          this.EquTypeArr = r[0].JValue;
          let servers = r[1].data.Data;
          let item = r[2].data.Data;
          item.forEach((detail) => {
            var server = servers.filter((a) => a.Name == detail.Name);
            detail.Status = server.length > 0 ? server[0].Status : 0;
          });
          servers.forEach((detail) => {
            var server = item.filter((a) => a.Name == detail.Name);
            detail.UseDetail = server.length > 0 ? server[0].UseDetail : null;
          });
          this.tableData = servers;
          this.searching = false;
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    convert(index, row) {
      var result = {
        index: index,
        id: row.ID,
        Name: row.Name,
        IP: row.IP,
        UseDetail: row.UseDetail == null ? null : JSON.parse(row.UseDetail),
        Status: row.Status,
      };
      return result;
    },
  },
};
</script>
<style lang="scss">
.refreshButton {
  float: right;
  margin: -5rem 1rem 3rem 1.5rem;
}
</style>
